import { BrowserRouter, Routes, Route } from "react-router";
import { DashboardLayout } from "../layout/DashboardLayout.tsx";
import HomePage from "../../pages/home/HomePage.tsx";
import PricePage from "../../pages/price/PricePage.tsx";
import MechanicsConfigurationPage from "../../pages/mechanicsConfiguration/MechanicsConfigurationPage.tsx";
import ElectronicsConfigurationPage from "../../pages/electronicsConfiguration/ElectronicsConfigurationPage.tsx";
import TestProceduresPage from "../../pages/testProcedures/TestProceduresPage.tsx";
import SummaryPage from "../../pages/summary/SummaryPage.tsx";
import PriceEstimationForm from "../../components/PriceEstimationForm.tsx";
import ProjectPage from "../../pages/project/ProjectPage.tsx"
import { MechanicsConfigurationProvider } from "../../context/MechanicsConfigurationContext.tsx";
import { ElectronicsConfigurationProvider } from "../../context/ElectronicsConfigurationContext.tsx";
import { TestProcedureProvider } from "../../context/TestProcedureContext.tsx";
import DeveloperPage from "../../pages/developer/Developer.tsx";
import TestProcedureDetailsPage from "../../pages/testProcedures/TestProcedureDetailsPage.tsx";
import { ColorModeContextProvider } from "../theme/ColorModeContextProvider.tsx";
import { MessageContextProvider } from "./../../context/MessageContext.tsx";
import { ProjectProvider } from "../../context/ProjectContext.tsx";

const AppRouter = () => {
  return(
    <ColorModeContextProvider>
      <MessageContextProvider>
        <ProjectProvider>
          <TestProcedureProvider>
            <ElectronicsConfigurationProvider>
              <MechanicsConfigurationProvider>
                <BrowserRouter>
                  <Routes>
                    <Route element={<DashboardLayout />}>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/project" element={<ProjectPage />} />
                      <Route
                        path="/mechanics"
                        element={<MechanicsConfigurationPage />}
                      />
                      <Route
                        path="/electronics"
                        element={<ElectronicsConfigurationPage />}
                      />
                      <Route path="/testprocedure" element={<TestProceduresPage />} />
                      <Route path="/testprocedure/:id" element={<TestProcedureDetailsPage />} />
                      <Route path="/summary" element={<SummaryPage />} />
                      <Route path="/price" element={<PricePage />} />
                      <Route path="/developer" element={<DeveloperPage />} />
                    </Route>  
                    <Route path="/priceestimation" element={<PriceEstimationForm />} />
                  </Routes>
                </BrowserRouter>
              </MechanicsConfigurationProvider>
            </ElectronicsConfigurationProvider>
          </TestProcedureProvider>
        </ProjectProvider>
      </MessageContextProvider>
    </ColorModeContextProvider>
)};

export default AppRouter;
